(function($) {
    'use strict';

    var $modal = $('#modal_intro');
    if ($modal.length === 0)  return;

    var $checkbox = $modal.find('#modal-intro-consent');
    var $dismissBtn = $modal.find('button[data-dismiss="modal"]');

    toggleDismissBtn();

    $checkbox.on('change', function() {
        toggleDismissBtn();
    });

    function toggleDismissBtn() {
        $dismissBtn.prop('disabled', !$checkbox.prop('checked'));
    }
})(require('jquery'));
